import { Box, styled, TableCell } from "@mui/material";
import isPropValid from "@emotion/is-prop-valid";

export const StickyTableCell = styled(TableCell)`
  position: sticky;
  left: 0;
  background-color: ${({ theme }) => theme.palette.background.paper};
  z-index: 3;
`;

export const GradientBox = styled(Box, {
  shouldForwardProp: (prop: string) => isPropValid(prop) || prop !== "mode",
})<{ mode: "dark" | "light" }>`
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 7px;
  height: 100%;
  background: linear-gradient(
    270deg,
    #e2e2e2 -125%,
    rgba(196, 196, 196, 0) 67.02%,
    rgba(196, 196, 196, 0) 246.43%
  );
  opacity: ${({ mode }) => (mode === "dark" ? 0.5 : 1)};
`;
